const Blockquote: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => (
  <div className="border-ornament my-16 border-l-2 pl-8">{children}</div>
);

export default Blockquote;
